module.exports = __webpack_public_path__ + "static/img/edff03eb7725a6155dfde55cc48185a4@2x.2f49c409.png";